import { motion } from "motion/react";
import MainCoin from "features/onboarding/overview/accountsList/MainCoin";
import useAccountMainCoins from "@shared/features/onboarding/hooks/useAccountMainCoins";
import { AccountMainCoinsProps } from "@shared/features/onboarding/types";
import styled from "styled-components";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import useGroupMainCoinsSignalsCount from "@shared/features/bots/BotForm/useGroupMainCoinsSignalsCount.tsx";

const AccountMainCoins = ({
  account,
  spans,
  isRadio,
}: AccountMainCoinsProps) => {
  const { mainCoinsToSignalsCount } = useGroupMainCoinsSignalsCount({});
  const { sortedMainCoinsData } = useAccountMainCoins(
    mainCoinsToSignalsCount,
    account.id,
    account.exchange
  );

  return (
    <LoadingSpinnerOverlay isLoading={!sortedMainCoinsData}>
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: "auto" }}
        transition={{ duration: 0.3 }}
        style={{ marginTop: 12 }}
      >
        {sortedMainCoinsData?.map((coinData, index) => {
          return (
            <MainCoinWrapper key={index}>
              <MainCoin coinData={coinData} spans={spans} isRadio={isRadio} />
            </MainCoinWrapper>
          );
        })}
      </motion.div>
    </LoadingSpinnerOverlay>
  );
};

export default AccountMainCoins;

const MainCoinWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 6px;
  }
`;
